// src/Component/Routing/RoutesComp.jsx
import { Route, Routes, Navigate } from "react-router-dom";
import LangLayout from "./LangLayout";
import Home from "../../Page/Home/Home";
import Service from "../../Page/Service/Service";
import AboutUs from "../../Page/AboutUs/AboutUs";
import ContactUs from "../../Page/ContactUs/ContactUs";
import Personel from "../../Page/Personel/Personel";
import Gallery from "../../Page/Gallery/Gallery";
import GalleryCompSwiper from "../Gallery/GalleryCompSwiper"
import LegacyGalleryRedirect from "./LegacyGalleryRedirect";

export default function RoutesComp() {
  return (
    <Routes>

      <Route path="/" element={<Navigate to="/fa" replace />} />

      <Route path=":lang" element={<LangLayout />}>
        <Route index element={<Home />} />
        <Route path="service" element={<Service />} />
        <Route path="aboutus" element={<AboutUs />} />
        <Route path="contactus" element={<ContactUs />} />
        <Route path="personel" element={<Personel />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery/:id" element={<GalleryCompSwiper />} />
      </Route>

      <Route path="/service" element={<Navigate to="/fa/service" replace />} />
      <Route path="/aboutus" element={<Navigate to="/fa/aboutus" replace />} />
      <Route path="/contactus" element={<Navigate to="/fa/contactus" replace />} />
      <Route path="/personel" element={<Navigate to="/fa/personel" replace />} />
      <Route path="/gallery" element={<Navigate to="/fa/gallery" replace />} />
      <Route path="/gallery/:id" element={<LegacyGalleryRedirect defaultLang="fa" />} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/fa" replace />} />
    </Routes>
  );
}
